var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8613 11.1332C19.8549 10.564 19.8527 9.99072 19.8506 9.4195H18.1183C18.1119 9.98861 18.1076 10.5598 18.1033 11.1332C17.5201 11.1353 16.9413 11.1395 16.3624 11.1458V12.851C16.9413 12.8574 17.5244 12.8616 18.1033 12.8679C18.1097 13.437 18.1097 14.0082 18.114 14.5773H19.8484C19.8506 14.0082 19.8549 13.437 19.8591 12.8637C20.4423 12.8574 21.0211 12.8552 21.6 12.8489V11.1437C21.0233 11.1395 20.4401 11.1395 19.8613 11.1332ZM8.49856 11.1416C8.49642 11.8224 8.49856 12.5053 8.50071 13.1862C9.6627 13.2241 10.8268 13.2072 11.9888 13.2241C11.4765 15.7598 7.97116 16.5819 6.11668 14.9251C4.2086 13.4728 4.29864 10.2879 6.28176 8.93892C7.66887 7.85129 9.63912 8.11898 11.0262 9.06117C11.5708 8.56584 12.081 8.03467 12.572 7.48663C11.4186 6.58238 10.0036 5.93739 8.49856 6.00484C5.35559 5.90156 2.46774 8.60799 2.41629 11.7002C2.21476 14.2274 3.90416 16.7041 6.28819 17.5978C8.66364 18.4979 11.7101 17.8845 13.228 15.7851C14.2292 14.4593 14.4458 12.752 14.3279 11.1479C12.3833 11.1332 10.4409 11.1353 8.49856 11.1416Z",
    fill: "#051655"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/socialGoogle.2899fcaecf679ea6aa77e05c6bfabcbe.svg";
export { ForwardRef as ReactComponent };